import * as ROUTES from '../common/routes';
import Button from './Button';
import React, { useCallback, useState, useEffect } from 'react';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { EUploadErrors } from '../common/enums';
import { StyleRules, createStyles, makeStyles } from '@mui/styles';
import { useDropzone } from 'react-dropzone';
import { v4 as uuidv4 } from 'uuid';
import { useTranslations } from '../common/hooks/useTranslations';
import { useDynamicTranslations } from '../common/hooks/useTranslations';

const SUPPORTED_ERRORS = [
  EUploadErrors.FILE_TOO_LARGE,
  EUploadErrors.FILE_INVALID_TYPE,
  EUploadErrors.TOO_MANY_FILES,
];

const TEXTS = {
  errors: {
    [EUploadErrors.FILE_TOO_LARGE]: 'Faila izmērs nedrīkst pārsniegt 30MB',
    [EUploadErrors.FILE_INVALID_TYPE]: 'Failam jābūt bildei, pdf vai audio',
    [EUploadErrors.TOO_MANY_FILES]: 'Drīkst pievienot līdz 20 datnēm',
  },
};

interface IProps {
  onFilesAdd: (acceptedFiles) => void;
  files?: any[];
  lng?: any;
}

const useStyles = makeStyles(
  (): StyleRules =>
    createStyles({
      dropZoneContainerStyle: {
        minWidth: '190px',
        height: '50px',
        maxHeight: '50px',
        display: 'flex',
        '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
        outline: 'none !important',
      },
      messageStyle: {
        position: 'absolute',
        top: '-20px',
        right: '10px',
        fontWeight: FONT_WEIGHT.medium,
        fontSize: '14px',
        fontFamily: FONTS.alegreya,
        color: COLORS.red,
      },
      buttonStyle: {
        width: '100%',
        color: COLORS.appButtonsGray,
        background: COLORS.appSand,
        outline: `1px dashed ${COLORS.appButtonsGray}`,
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            color: COLORS.appBlack,
            background: COLORS.appMenuHoverSand,
            transition: '0.5s ease',
            outline: `1px dashed ${COLORS.appButtonsGray}`,
          },
        },
      },
    })
);

const DropZoneContainer = ({ onFilesAdd, files, lng }: IProps): JSX.Element => {
  const classes = useStyles();
  const addfilesLabel = useDynamicTranslations('addfiles', lng);

  const [errorMessage, setErrors] = useState('');

  /*
  const onDrop = useCallback((acceptedFiles) => {
    // setFiles(acceptedFiles.map(file => Object.assign(file, {
    //   preview: URL.createObjectURL(file)
    // })));
    const currentFile = acceptedFiles[0];
    // setFile(Object.assign(currentFile, {
    //   preview: URL.createObjectURL(currentFile)
    // }));
    onImageAdd(currentFile);
  }, []);

  // useEffect(() => () => {
  //   // Make sure to revoke the data uris to avoid memory leaks
  //   // files.forEach(file => URL.revokeObjectURL(file.preview));
  //   URL.revokeObjectURL(file.preview);
  // }, [file]);
  */

  const onDrop = useCallback((acceptedFiles) => {
    setErrors('');
    acceptedFiles.forEach((file) => {
      /*
      const reader = new FileReader();

      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = () => {
        // Do whatever you want with the file contents
        const binaryStr = reader.result;
        // console.log(binaryStr);
      };
      reader.readAsArrayBuffer(file);
      */
      // setFiles((prevState) => {
      //   const currentFiles = [...prevState, file];
      //   const newFiles =
      //     currentFiles.length > 5 ? [...prevState] : currentFiles;
      //   onImageAdd(newFiles);
      //   return newFiles;
      // });
      const uuid = uuidv4();
      file.uuid = uuid;
    });

    onFilesAdd(acceptedFiles);
  }, []);

  const onDropRejected = (error) => {
    error.forEach((file) => {
      file.errors.forEach((err) => {
        if (SUPPORTED_ERRORS.includes(err.code)) {
          // `Error: ${err.message}`
          setErrors(TEXTS.errors[err.code]);
        }
      });
    });
  };

  const { acceptedFiles, getRootProps, getInputProps, isDragActive } =
    useDropzone({
      onDrop,
      maxFiles: 20,
      maxSize: 157286400, // 31457280, // 30mb // 2097152 - 2mb, 5242880 - 5mb
      accept: 'image/*,.pdf,audio/*,.doc,.docx,.txt',
      multiple: true,
      onDropRejected,
    });

  return (
    <>
      <div className={classes.messageStyle}>{errorMessage}</div>
      <div {...getRootProps()} className={classes.dropZoneContainerStyle}>
        <input {...getInputProps()} />
        <Button text={addfilesLabel} className={classes.buttonStyle} />
      </div>
    </>
  );
};

export default DropZoneContainer;
